(function () {
  if (window.__cnChooseGiftWired) return;
  window.__cnChooseGiftWired = true;

  var SECTION_IDS = 'cart-drawer,cart-icon-bubble';
  var SUPPRESS = false;

  function getConfig() {
    var el = document.getElementById('cn-cg-config');
    if (!el) return null;
    try {
      var cfg = JSON.parse(el.textContent);
      cfg.giftSet = new Set((cfg.giftVariantIds || []).map(String));
      return cfg;
    } catch (e) {
      return null;
    }
  }

  function showError(msg) {
    var notification = document.querySelector('cart-notification');
    if (notification && typeof notification.renderError === 'function') {
      notification.renderError(msg);
      return;
    }
    var existing = document.querySelector('.cart-error-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'cart-error-toast';
    toast.setAttribute('role', 'alert');
    toast.textContent = msg;
    toast.style.cssText = [
      'position:fixed', 'bottom:24px', 'left:50%', 'transform:translateX(-50%)',
      'z-index:9999', 'background:#353535', 'color:#fff', 'padding:14px 22px',
      'border-radius:4px', 'font-family:var(--font-body-family-override,sans-serif)',
      'font-size:14px', 'letter-spacing:0.01em',
      'box-shadow:0 8px 24px -10px rgba(0,0,0,0.3)', 'max-width:90vw'
    ].join(';');
    document.body.appendChild(toast);
    setTimeout(function () {
      toast.style.transition = 'opacity 250ms ease, transform 250ms ease';
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(10px)';
      setTimeout(function () { toast.remove(); }, 260);
    }, 4000);
  }

  function readCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function refreshDrawerOrReload() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ sections: SECTION_IDS })
    })
      .then(function (r) { return r.json(); })
      .then(function (parsed) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && parsed && parsed.sections) {
          drawer.renderContents(parsed);
        } else {
          window.location.reload();
        }
      })
      .catch(function () { window.location.reload(); });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function addVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: { _fathers_day_gift: '1' } })
    }).then(function (r) {
      if (!r.ok) {
        return r.text().then(function (txt) {
          var msg = 'Could not add your free gift to cart.';
          try { var p = JSON.parse(txt); if (p && p.description) msg = p.description; } catch (_) {}
          throw new Error(msg);
        });
      }
      return r.json();
    });
  }

  // Remove every configured gift line currently in the cart (enforces one-only).
  function removeAllGiftLines(cart, giftSet) {
    var giftLines = (cart.items || []).filter(function (l) {
      return giftSet.has(String(l.variant_id || l.id));
    });
    if (!giftLines.length) return Promise.resolve();
    // Remove by key sequentially (keys stay valid because /change.js by key).
    return giftLines.reduce(function (chain, line) {
      return chain.then(function () { return changeLine(line.key, 0); });
    }, Promise.resolve());
  }

  // Subtotal of NON-gift items, using each line's original price (pre-discount).
  function nonGiftSubtotal(cart, giftSet) {
    return (cart.items || []).reduce(function (sum, l) {
      if (giftSet.has(String(l.variant_id || l.id))) return sum;
      var unit = (typeof l.original_price === 'number') ? l.original_price : l.price;
      return sum + unit * l.quantity;
    }, 0);
  }

  async function claim(btn, cfg) {
    var card = btn.closest('[data-cn-cg]');
    var checked = card && card.querySelector('.cn-cg__radio:checked');
    // If the chosen gift has a flavor picker, claim the selected flavor's
    // variant; otherwise the radio's own value.
    var option = checked && checked.closest('.cn-cg__option');
    var flavorSel = option && option.querySelector('[data-cn-cg-flavor]');
    var variantId = parseInt((flavorSel && flavorSel.value) || (checked && checked.value), 10);
    if (!variantId || isNaN(variantId)) {
      throw new Error('Please choose a gift first.');
    }

    SUPPRESS = true;
    try {
      var cart = await readCart();
      if (nonGiftSubtotal(cart, cfg.giftSet) < cfg.threshold) {
        throw new Error('Add a bit more to qualify for your free gift.');
      }
      await removeAllGiftLines(cart, cfg.giftSet); // one-only: clear any prior pick
      await addVariant(variantId);
      if (cfg.code) {
        try { await fetch('/discount/' + encodeURIComponent(cfg.code), { redirect: 'follow' }); } catch (e) {}
      }
      await refreshDrawerOrReload();
    } finally {
      setTimeout(function () { SUPPRESS = false; }, 400);
    }
  }

  async function removeGift(btn) {
    var lineKey = btn.getAttribute('data-line-key');
    if (!lineKey) throw new Error('Missing line key.');
    SUPPRESS = true;
    try {
      await changeLine(lineKey, 0);
      await refreshDrawerOrReload();
    } finally {
      setTimeout(function () { SUPPRESS = false; }, 400);
    }
  }

  // Safety net: if the cart drops back under the threshold, pull the free gift
  // so a "free" item never silently becomes a paid one.
  function reconcile() {
    var cfg = getConfig();
    if (!cfg || !cfg.enabled || SUPPRESS) return Promise.resolve();
    return readCart().then(function (cart) {
      var hasGift = (cart.items || []).some(function (l) {
        return cfg.giftSet.has(String(l.variant_id || l.id));
      });
      if (hasGift && nonGiftSubtotal(cart, cfg.giftSet) < cfg.threshold) {
        SUPPRESS = true;
        return removeAllGiftLines(cart, cfg.giftSet)
          .then(refreshDrawerOrReload)
          .finally(function () { setTimeout(function () { SUPPRESS = false; }, 400); });
      }
      return null;
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var claimBtn = e.target.closest('[data-cn-cg-claim]');
    var removeBtn = e.target.closest('[data-cn-cg-remove]');
    if (!claimBtn && !removeBtn) return;
    e.preventDefault();
    var btn = claimBtn || removeBtn;
    if (btn.disabled) return;
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Working…';

    var cfg = getConfig() || { giftSet: new Set(), threshold: 0 };
    var p = claimBtn ? claim(claimBtn, cfg) : removeGift(removeBtn);
    p.catch(function (err) {
      if (document.body.contains(btn)) {
        btn.disabled = false;
        btn.textContent = originalText;
      }
      showError((err && err.message) || 'Something went wrong.');
    });
  });

  // Choosing a flavor also selects that gift's radio (in case it wasn't).
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-cn-cg-flavor]');
    if (!sel) return;
    var option = sel.closest('.cn-cg__option');
    var radio = option && option.querySelector('.cn-cg__radio');
    if (radio && !radio.checked) radio.checked = true;
  });

  // React to cart mutations made elsewhere (qty changes, removals) -> reconcile.
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = (args[0] && args[0].url) || args[0] || '';
    url = String(url);
    var isCartWrite = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    var p = origFetch.apply(this, args);
    if (isCartWrite && !SUPPRESS) {
      p.then(function () { setTimeout(reconcile, 150); }).catch(function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
